import UIPopper from "../popover";
import UIList, { UIListItem } from "../list";
import GetIcon from "../font-awesome-icon";
import UIIconButton from "../ui-controls/icon-button";
import { faEllipsisVertical } from "@fortawesome/free-solid-svg-icons";
import { Divider, useTheme } from "@mui/material";
import { Fragment } from "react";

const GridActionPopover = ({
  handleClick,
  options = [],
  clickNodeStyles = {},
  otherOptions = [],
  customClickNode,
  disabled = false,
  menuPlacement = "bottom",
  menuAlign = "right",
  paperStyles = {},
}) => {
  const clickItem = (callback, closePopOver) => {
    if (callback) callback();
    // Delay closing to prevent focus-related scroll jumps
    setTimeout(() => closePopOver(null), 0);
  };
  const { palette } = useTheme();
  const opensUpward = menuPlacement === "top";
  const opensLeft = menuAlign === "left";
  const anchorOrigin = {
    vertical: opensUpward ? "top" : "bottom",
    horizontal: opensLeft ? "left" : "right",
  };
  const transformOrigin = {
    vertical: opensUpward ? "bottom" : "top",
    horizontal: opensLeft ? "left" : "right",
  };

  return (
    <UIPopper
      // onClose={mapColumnsToCheckBox}
      paperStyles={{ p: 1, minWidth: 90, ...paperStyles }}
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
      clickNode={
        customClickNode ? (
          customClickNode
        ) : (
          <UIIconButton
            title={
              <GetIcon
                icon={faEllipsisVertical}
                iconStyles={{
                  margin: "0px 5px",
                  fontSize: "0.9rem",
                  color: palette.custom.grey_text,
                  background: palette.custom.grid_header,
                  ...clickNodeStyles,
                }}
              />
            }
            variant="outlined"
            disabled={!!!options.length || disabled}
            style={{
              color: palette.custom.grey_text,
              background: palette.custom.grid_header,
              p: 0.8,
              ...clickNodeStyles,
            }}
          />
        )
        // <UIButton
        //   key={1}
        //   title={<GetIcon title="Actions"  />}
        // />
      }
    >
      {({ setAnchorEl }) => {
        return (
          <UIList sx={{ p: 0 }}>
            {options.map((opt, ind) =>
              opt.component ? (
                opt.component
              ) : (
                <Fragment key={ind}>
                  <UIListItem
                    key={ind}
                    id={opt?.id || ind}
                    title={opt?.name || ""}
                    sx={{ py: 0, my: 0 }}
                    textStyle={{
                      fontSize: "0.8rem",
                      // color: palette.base[100],
                    }}
                    handleItemClick={(e) => {
                      e?.stopPropagation?.();
                      e?.preventDefault?.();
                      clickItem(opt?.callback, setAnchorEl);
                    }}
                    disabled={opt.disabled}
                  />
                  {opt.divider ? <Divider key={`${ind}-D`} /> : null}
                </Fragment>
              ),
            )}

            {!!otherOptions.length && (
              <Divider orientation="horizontal" variant="middle" />
            )}
            {otherOptions.map((opt, ind) =>
              opt.component ? (
                opt.component
              ) : (
                <UIListItem
                  key={ind}
                  id={opt?.id || ind}
                  title={opt?.name || ""}
                  sx={{ py: 0, my: 0 }}
                  textStyle={{ fontSize: "0.8rem" }}
                  handleItemClick={(e) => {
                    e?.stopPropagation?.();
                    e?.preventDefault?.();
                    clickItem(opt?.callback, setAnchorEl);
                  }}
                  disabled={opt.disabled}
                />
              ),
            )}

            {/* <UIListItem
              id={2}
              title={"Bulk Delete"}
              handleItemClick={(e) => clickItem(e, setAnchorEl)}
            /> */}
          </UIList>
        );
      }}
    </UIPopper>
  );
};

export default GridActionPopover;
